import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { featureFlags } from '@/lib/feature-flags'
import { StudioLayout } from '@/pages/studio-mock/components/studio-layout'

export const Route = createFileRoute('/_protected/studio')({
  beforeLoad: () => {
    if (!featureFlags.studio) {
      throw redirect({ to: '/' })
    }
  },
  component: () => (
    <StudioLayout>
      <Outlet />
    </StudioLayout>
  ),
})
